import { fabric } from "fabric";

import { Arrow, CustomPolygon, InteractiveText } from "./shapes";

import {
  FREE_DRAWING,
  FILLED_RECTANGLE,
  DASHED_RECTANGLE,
  FILLED_CIRCLE,
  DASHED_CIRCLE,
  ARROW,
  TEXT,
  LINE,
  TRIANGLE,
  FILLED_TRIANGLE
} from "~/constants/shape-types";

const { Rect, Polyline, Ellipse, Line } = fabric;

export const DEFAULT_SIZE = 100;

export const freeDrawingDefaults = {
  backgroundColor: "transparent",
  fill: "transparent",
  strokeWidth: 4
  // strokeUniform: true
};

export const filledRectangleDefaults = {
  width: DEFAULT_SIZE,
  height: DEFAULT_SIZE,
  fill: "blue",
  strokeWidth: 0,
  stroke: "",
  strokeUniform: true
};

export const dashedRectangleDefaults = {
  width: DEFAULT_SIZE,
  height: DEFAULT_SIZE,
  fill: "",
  strokeWidth: 2,
  stroke: "red",
  strokeUniform: true
};

export const filledCircleDefaults = {
  rx: DEFAULT_SIZE / 2,
  ry: DEFAULT_SIZE / 2,
  fill: "orange",
  strokeWidth: 0,
  stroke: "",
  strokeUniform: true
};

export const dashedCircleDefaults = {
  rx: DEFAULT_SIZE / 2,
  ry: DEFAULT_SIZE / 2,
  fill: "",
  strokeWidth: 2,
  stroke: "red",
  strokeUniform: true
};

export const arrowDefaults = {
  fill: "black",
  stroke: "black",
  strokeWidth: 2,
  selectable: true,
  hasControls: false,
  hasBorders: true,
  centeredRotation: false,
  centeredScaling: false
};
export const lineDefaults = {
  fill: "black",
  stroke: "black",
  strokeWidth: 2,
  selectable: true,
  hasControls: false,
  hasBorders: true,
  centeredRotation: false,
  centeredScaling: false
};

export const textDefaults = { fill: "black" };

export function createShape(type, { points, width, height, ...options }, color, strokeWidth) {
  switch (type) {
    case FREE_DRAWING:
      options.stroke = color;
      options.strokeWidth = strokeWidth;
      return makeFreeDrawing([], options);
    case FILLED_RECTANGLE:
      options.fill = color;
      options.strokeWidth = strokeWidth;
      return makeFilledRectangle(options);
    case DASHED_RECTANGLE:
      options.stroke = color;
      options.strokeWidth = strokeWidth;
      return makeDashedRectangle(options);
    case FILLED_CIRCLE:
      options.fill = color;
      options.strokeWidth = strokeWidth;
      return makeFilledCircle(options);
    case DASHED_CIRCLE:
      options.stroke = color;
      options.strokeWidth = strokeWidth;
      return makeDashedCircle(options);
    case ARROW:
      options.strokeWidth = strokeWidth;
      console.log("options", { options, strokeWidth });
      return makeArrow(points ?? [], options, color);
    case LINE:
      options.stroke = color;
      options.strokeWidth = strokeWidth;
      return makePolygon({ points, options, maxPoints: 2 }); // test use polygon
    // return makeLine(points ?? [], options, color);
    case TEXT:
      options.fill = color;
      return makeText(undefined, options);
    case TRIANGLE:
      options.strokeWidth = strokeWidth;
      options.stroke = color;
      return makePolygon({ points, options, maxPoints: 3 });
    case FILLED_TRIANGLE:
      options.strokeWidth = strokeWidth;
      options.stroke = color;
      options.fill = color;
      return makePolygon({ points, options, color, maxPoints: 3 });
    default:
      console.error(`Unknown shape type [${type}]`);
  }
}

export function makeFreeDrawing(points, options) {
  return new Polyline(points, { ...freeDrawingDefaults, ...options });
}

export function makeFilledRectangle(options) {
  return new Rect({ ...filledRectangleDefaults, ...options });
}

export function makeDashedRectangle(options) {
  return new Rect({ ...dashedRectangleDefaults, ...options });
}

export function makeFilledCircle(options) {
  return new Ellipse({ ...filledCircleDefaults, ...options });
}

export function makeDashedCircle(options) {
  return new Ellipse({ ...dashedCircleDefaults, ...options });
}
export function makeLine(points, options, color) {
  console.log("makeLine");
  let coordinates = [];
  if (points.length < 4) {
    coordinates = [...points, ...points];
  } else {
    coordinates = points;
  }
  return new Line(coordinates, { ...lineDefaults, ...options }, color);
}

export function makeArrow(points, options, color) {
  let coordinates = [];
  if (points.length < 4) {
    coordinates = [...points, ...points];
  } else {
    coordinates = points;
  }

  return new Arrow(coordinates, { ...arrowDefaults, ...options }, color);
}

export function makePolygon({ points, options, color, maxPoints }) {
  return new CustomPolygon([{ x: points[0], y: points[1] }], options, maxPoints);
}

export function makeText(text, options) {
  return new InteractiveText(text, { ...textDefaults, ...options });
}
